module.exports = __webpack_public_path__ + "static/media/financialit.10dd7ca4.jpeg";